import { render, staticRenderFns } from "./editFoodPackModal.vue?vue&type=template&id=ce4461ec&scoped=true&"
import script from "./editFoodPackModal.vue?vue&type=script&lang=js&"
export * from "./editFoodPackModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4461ec",
  null
  
)

export default component.exports